module.exports = __webpack_public_path__ + "img/login-bg.f1d7701e.png";